import React from 'react';

export default (_props) => {
  const { className, size, large, small, ...props } = _props;

  // small icon
  if ((size && size.toLowerCase() === 'small') || small) {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" className={`audiicon audiicon-small ${className ? className : ''}`} {...props}>
        <g stroke="currentColor" strokeWidth="1" fill="none" fillRule="evenodd">
          <circle cx="19.5" cy="20.5" r="2"/>
          <circle cx="10.5" cy="20.5" r="2"/>
          <path d="M6.4,9.5 L21.7,9.5 M5,5.5 L23,5.5 L20.5,13.5 L7.9,13.5"/>
          <path d="M0 1.5L3.5 1.5 9 16.5"/>
        </g>
      </svg>
    );
  }

  // large icon
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" className={`audiicon audiicon-large ${className ? className : ''}`} {...props}>
      <g stroke="currentColor" strokeWidth="1" fill="none" fillRule="evenodd">
        <circle cx="38.5" cy="41.5" r="3"/>
        <circle cx="22.5" cy="41.5" r="3"/>
        <path d="M13.8,19.5 L43.8,19.5 M10.6,11.5 L46.5,11.5 L41,27.5 L16.9,27.5"/>
        <path d="M1 3.5L7.5 3.5 20 35.5"/>
      </g>
    </svg>
  );
};
